export const bingads = (partnersIds) => {
  Object.entries(partnersIds).forEach(([partnerId, partnerOptions]) => {
    ;(function (w, d, t, r, u) {
      let f
      let n
      let i
      ;(w[u] = w[u] || []),
      (f = function () {
          let o = {
          ti: partnerId,
        }
          ;(o.q = w[u]), (w[u] = new UET(o)), w[u].push('pageLoad')
      }),
      (n = d.createElement(t)),
      (n.src = r),
      (n.async = 1),
      (n.onload = n.onreadystatechange =
          function () {
            const s = this.readyState
            ;(s && s !== 'loaded' && s !== 'complete') ||
              (f(), (n.onload = n.onreadystatechange = null))
          }),
      (i = d.getElementsByTagName(t)[0]),
      i.parentNode.insertBefore(n, i)
    })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq')

    if ('events' in partnerOptions) {
      callEvents(partnerOptions.events)
    }
  })

  function callEvents(tracks) {
    Object.entries(tracks).forEach(([index, track]) => {
      window.uetq = window.uetq || []

      if (track.type == 'checkout') {
        window.uetq.push('event', 'begin_checkout', {})
        return
      }

      if (track.type == 'purchase') {
        window.uetq.push('event', 'purchase', {
          event_value: track.params.value,
          currency: track.params.currency,
        })
      }
    })
  }
}
